import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async getQnaList(param) {
        const response = await service.get(`${getApiBaseUrl()}qna`, param);
        return response;
    },

    async getQna(id) {
        const response = await service.get(`${getApiBaseUrl()}qna/${id}`);
        return response;
    },

    async addQna(qna) {
        const response = await service.post(`${getApiBaseUrl()}qna`, qna);
        return response;
    },

    async updateQna(qna) {
        const response = await service.patch(`${getApiBaseUrl()}qna`, qna);
        return response;
    },

    async deleteQna(qna_id) {
        const response = await service.delete(
            `${getApiBaseUrl()}qna/${qna_id}`
        );
        return response;
    },

    async updateAnswer(qna_id, args) {
        const response = await service.patch(`${getApiBaseUrl()}qna/${qna_id}/answer`, args);
        return response;
    }
};
